export const fractionToPercent = (fraction: number) => Math.round(fraction * 100);
